import html from "html-literal";

export default () => html`
  <section id="jumbotron">
    <a id="callToAction">Where are your Vulnerabilities?</a>
  </section>
`;
